import { buildAuthHeaders } from '../utils/authHeaders';

export class CancellationService {
  static async request(companyId: string, userId: string): Promise<Date> {
    const { buildFunctionUrl } = await import('../utils/functionsUrl');
    const res = await fetch(buildFunctionUrl('requestCancellationV3'), {
      method: 'POST',
      headers: await buildAuthHeaders(),
      body: JSON.stringify({ companyId }),
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.error || 'Failed to request cancellation');
    }

    const data = await res.json();
    return new Date(data.effectiveAt);
  }

  static async revoke(companyId: string, userId: string): Promise<void> {
    const { buildFunctionUrl } = await import('../utils/functionsUrl');
    const res = await fetch(buildFunctionUrl('revokeCancellationV3'), {
      method: 'POST',
      headers: await buildAuthHeaders(),
      body: JSON.stringify({ companyId }),
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.error || 'Failed to revoke cancellation');
    }
  }
}


